var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNuxtJs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 2500,
    viewBox: "-.65894164 8.03694707 65.54579331 48.12892285",
    width: 2500,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "m19.455 54.151a2.378 2.378 0 0 1 -.127-.26 3.334 3.334 0 0 1 -.226-1.88h-15.13l22.485-39.57 7.382 12.977 2.14-3.787-6.435-11.336a3.933 3.933 0 0 0 -3.14-2.074 3.496 3.496 0 0 0 -3.048 2.1l-22.779 40.05a4.028 4.028 0 0 0 -.2 3.78 3.505 3.505 0 0 0 3.334 1.608h19.079a3.496 3.496 0 0 1 -3.334-1.608z",
    fill: "#00c492"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m63.319 50.37-18.719-32.973a3.943 3.943 0 0 0 -3.154-2.1 3.486 3.486 0 0 0 -3.046 2.093l-2.421 4.24 2.154 3.788 3.333-5.901 18.519 32.493h-7.042a3.153 3.153 0 0 1 -.147 1.6 2.029 2.029 0 0 1 -.147.327l-.06.12a4.03 4.03 0 0 1 -3.394 1.7h11.016a4.024 4.024 0 0 0 3.394-1.7 3.497 3.497 0 0 0 -.286-3.687z",
    fill: "#008776"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m52.59 54.058.06-.12a2.029 2.029 0 0 0 .146-.327 3.153 3.153 0 0 0 .147-1.6 4.873 4.873 0 0 0 -.614-1.64l-14.182-24.953-2.167-3.787-2.154 3.787-14.177 24.953a5.052 5.052 0 0 0 -.547 1.64 3.334 3.334 0 0 0 .207 1.881 2.354 2.354 0 0 0 .127.26 3.505 3.505 0 0 0 3.334 1.607h26.405a4.04 4.04 0 0 0 3.414-1.7zm-16.611-24.852 12.963 22.804h-25.92z",
    fill: "#2d4a5d"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNuxtJs);
export default __webpack_public_path__ + "static/media/nuxt-js.fc96e7bc58ae3a91d3cbe6363d2070f5.svg";
export { ForwardRef as ReactComponent };